import { Typography } from '@mui/material';
import { useDomains } from '@schamburg-web/components';
import React, { useEffect, useState } from 'react';
import { getUpdated } from '../../modules/utils';

interface UpdatedTimeStampProps {
  icon: unknown;
  sx?: React.CSSProperties;
  prefix?: string;
  fieldName?: string;
}

const UpdatedTimeStamp: React.FC<UpdatedTimeStampProps> = ({
  icon,
  sx,
  prefix,
  fieldName,
}) => {
  const { domains } = useDomains();
  const [, forceUpdate] = useState(0);

  const maxAge = React.useMemo(() => {
    return domains.find(
      (d) => d.name === 'extWebsite.event.lastUpdateMsg.maxAgeInMin'
    )?.value;
  }, [domains]);

  // Use 0 for maxAge in development, otherwise use the domain value   //import.meta.env.DEV ? '0' :
  const effectiveMaxAge = maxAge;

  // Force re-render every minute to update relative time
  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate((prev) => prev + 1);
    }, 60000); // 60 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      fontStyle={'italic'}
      sx={sx ? { ...sx } : { paddingTop: '0px' }}
    >
      {`${prefix ? prefix : ''} ${getUpdated(
        icon,
        effectiveMaxAge,
        fieldName
      )}`}
    </Typography>
  );
};

export default UpdatedTimeStamp;
